import { TranslationObject } from '../../i18n/translation';

const namespace = 'agreementdetails';
const translations: TranslationObject = {
  navnLabel: {
    id: `${namespace}.navnLabel`,
    nb: 'Navn på samarbeidsavtalen',
    en: 'Agreement name',
  },
  navnPlaceholder: {
    id: `${namespace}.navnPlaceholder`,
    nb: 'Eks. Samarbeidsavtale mellom universitetet og praksisstedet',
    en: 'Example: Agreement between the university and the practice place',
  },
  saksnrLabel: {
    id: `${namespace}.saksnrLabel`,
    nb: 'Saksnr./arkivnr.',
    en: 'Case/archive no.',
  },
  saksnr: {
    id: `${namespace}.saksnr`,
    nb: 'Genereres etter innsending',
    en: 'Is generated after submit',
  },
  startdato: {
    id: `${namespace}.startdato`,
    nb: 'Avtalestart',
    en: 'Agreement start date',
  },
  startdatoPlaceholder: {
    id: `${namespace}.startdatoPlaceholder`,
    nb: 'Velg avtalens startdato',
    en: 'Set agreement start date',
  },
  sluttdatoPlaceholder: {
    id: `${namespace}.sluttdatoPlaceholder`,
    nb: 'Ingen utløpsdato',
    en: 'No expiration date',
  },
  sluttdato: {
    id: `${namespace}.sluttdato`,
    nb: 'Utløpsdato',
    en: 'Expiration date',
  },
  ansvarlig: {
    id: `${namespace}.ansvarlig`,
    nb: 'Ansvarlig',
    en: 'Responsible party',
  },
  ingen: {
    id: `${namespace}.ingen`,
    nb: 'Ingen',
    en: 'None',
  },
};

export default translations;
